import { useNavigate } from 'react-router'

import { Container } from '../../../components/Container'
import { Section } from '../../../components/Section'
import { Steps } from '../../../components/Steps'
import { StepsContent } from '../../../context/StepsContext'

import type { Step1FormValues } from '../../../containers/sme/Step1Form'
import { Step1Form } from '../../../containers/sme/Step1Form'

export const Step1 = () => {
  const navigate = useNavigate()

  const handleSubmit = (values: Step1FormValues) => {
    console.log(values)
    navigate('/sme/wizard/2')
  }

  return (
    <Section>
      <Container>
        <StepsContent step={1}>
          <Steps icon="briefcase" />

          <Step1Form onSubmit={handleSubmit} />
        </StepsContent>
      </Container>
    </Section>
  )
}
